import generalServices from '../services/general';

const deleteCharacters = (txt) => {
	const options = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
	return txt.split('').map( letter => options[letter] || letter).join('').toString();	
}

const getIpClient = async () => {
    const resp = await fetch(global.GET_IP)
    const response = await resp.json();
    return response;
}

const getDepartamentosLogic = async (userToken) => {
	const dataResp = await generalServices.getDepartamentos(userToken);
    return dataResp;
}

const statusProductsLogic = async (userToken) => {
	const dataResp = await generalServices.statusProducts(userToken);
    return dataResp;
}

const getCategoriaPorDepartLogic = async (userToken, idDepartamento) => {
	const dataResp = await generalServices.getCategoriaPorDepart(userToken, idDepartamento);
    return dataResp;
}

const getTipoProdCategoriaLogic = async (userToken, idCategoria) => {
	const dataResp = await generalServices.getTipoProdCategoria(userToken, idCategoria);
    return dataResp;
}

const getMarcaTipoProdLogic = async (userToken, idTipoProd) => {
	const dataResp = await generalServices.getMarcaTipoProd(userToken, idTipoProd);
    return dataResp;
}

const getTipoBodegaLogic = async (userToken) => {
	const dataResp = await generalServices.getTipoBodegaServices(userToken);
    return dataResp;
}

const getBodegaLogic = async (userToken) => {
	const dataResp = await generalServices.getBodegaServices(userToken);
    return dataResp;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    deleteCharacters,
	getIpClient,
    getDepartamentosLogic,
    getCategoriaPorDepartLogic,
    getTipoProdCategoriaLogic,
    getMarcaTipoProdLogic,
    statusProductsLogic,
    getTipoBodegaLogic,
    getBodegaLogic
}
